export default "__VITE_ASSET__WHvzyCkH__"